import { DealStatusStageMappingAPI } from '@business/api/deal';
import {
  DealBoardId,
  DealStatusStageMappingData,
  DealStatusStageMappingId,
  DealStatusStageMappingResponse,
} from '@business/entities/deal';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class DealStatusStageMappingBloc extends BaseBloc {
  private readonly mappingRepo = new Repository<DealStatusStageMappingResponse>({
    getItemId: item => item.id,
  });

  readonly items$ = this.mappingRepo.items$;
  readonly selectItem = this.mappingRepo.selectItem;

  onReset() {
    this.mappingRepo.reset();
  }

  fetchMappings = (boardId?: DealBoardId) => {
    return DealStatusStageMappingAPI.fetchMappings(boardId).pipe(
      this.mappingRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_deal_status_stage_mappings_error') }),
    );
  };

  createMapping = (data: DealStatusStageMappingData) => {
    return DealStatusStageMappingAPI.createMapping(data).pipe(
      this.mappingRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ type: requestMessage('create_deal_status_stage_mapping') }),
    );
  };

  updateMapping = (id: DealStatusStageMappingId, data: Partial<Pick<DealStatusStageMappingData, 'stageId' | 'active'>>) => {
    return DealStatusStageMappingAPI.updateMapping(id, data).pipe(
      this.mappingRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ type: requestMessage('update_deal_status_stage_mapping') }),
    );
  };

  deleteMapping = (id: DealStatusStageMappingId) => {
    return showDeleteConfirmation('Remove Automation', 'Do you really want to remove this status automation?').pipe(
      switchMap(() => DealStatusStageMappingAPI.deleteMapping(id)),
      this.mappingRepo.ops.removeOne(() => id),
      handleMessage({ type: requestMessage('delete_deal_status_stage_mapping') }),
    );
  };
}
